const EmptyNote = ({ emoji, children }) => (
  <div className="bg-white dark:bg-gray-700 rounded-2xl p-8 text-center shadow-sm border border-gray-200 dark:border-gray-600">
    <div className="text-4xl mb-3" aria-hidden="true">{emoji}</div>
    <p className="opacity-80">{children}</p>
  </div>
);

export default EmptyNote;
